import React, { useContext } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CareGiverContext } from "./context/CareGiverContext";
import Layout from "./components/Layout";
import CareGiverBookings from "./pages/CareGiverBookings";
import CareGiverDashboard from "./pages/CareGiverDashboard";
import CareGiverProfile from "./pages/CareGiverProfile";
import CaregiverRequestList from "./pages/CaregiverRequestList";
import CareGiverApplicationStatus from "./pages/CareGiverApplicationStatus";
import CareGiverContracts from "./pages/CareGiverContracts";
import CareGiverPayments from "./pages/CareGiverPayments";
import CareGiverHelp from "./pages/CareGiverHelp";
import CareGiverArticle from "./pages/CareGiverArticle";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";

const App = () => {
  const { cToken } = useContext(CareGiverContext);

  return (
    <div className="bg-[#F8F9FD]">
      <ToastContainer />
      {cToken ? (
        <Layout>
          <Routes>
            <Route
              path="/"
              element={<Navigate to="/caregiver/dashboard" />}
            />
            <Route
              path="/caregiver/dashboard"
              element={<CareGiverDashboard />}
            />
            <Route
              path="/caregiver/bookings"
              element={<CareGiverBookings />}
            />
            <Route
              path="/caregiver/profile"
              element={<CareGiverProfile />}
            />
            <Route
              path="/caregiver/request/apply"
              element={<CaregiverRequestList />}
            />
            <Route
              path="/caregiver/application-status"
              element={<CareGiverApplicationStatus />}
            />
            <Route
              path="/caregiver/contracts"
              element={<CareGiverContracts />}
            />
            <Route
              path="/caregiver/payments"
              element={<CareGiverPayments />}
            />
            <Route path="/caregiver/help" element={<CareGiverHelp />} />
            <Route
              path="/caregiver/help/article/:id"
              element={<CareGiverArticle />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      ) : (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </div>
  );
};

export default App;
